//
//
//
//
//

import xnts from './images/xnkt.png';
export default {
  data(){
    return {
      xnts
    }
  },
  methods:{
  },
  mounted(){

  }
}



// WEBPACK FOOTER //
// ./src/project/articleProject/xnkt.vue